import type {
  ApiVaultInfo,
  ApiVaultPreferences,
  ApiVaultTransferContact,
  ApiVaultTransferUpdateContact,
} from '@izimi/api';
import { getElementsNotInSecondArray } from '@izimi/utils';

import VaultInfoEntity from './VaultInfoEntity';
import VaultPreferences from './VaultPreferences';

export const mapVaultInfoToEntity = (vaultInfo: ApiVaultInfo) => new VaultInfoEntity(vaultInfo);

export const mapVaultPreferencesToEntity = (vaultPreferences: ApiVaultPreferences) =>
  new VaultPreferences(vaultPreferences);

export const mapVaultPreferencesContactsToUpdate = (
  contacts: Array<ApiVaultTransferContact>,
): Array<ApiVaultTransferUpdateContact> =>
  contacts.map((c) => {
    return {
      userId: c.contact.userId,
      selectionType: c.documentSelectionType,
      documents: c.documents.map((d) => d.documentId),
    };
  });

export const getAffectedContactsAndTheirDeselectedDocuments = (
  contactsDocumentSelection: Array<ApiVaultTransferContact>,
  selectedDocumentIds: Array<string>,
) => {
  return contactsDocumentSelection.reduce(
    (acc, contact) => {
      const contactDocumentIds = contact.documents.map((d) => d.documentId);
      const deselectedDocumentIds = getElementsNotInSecondArray(
        contactDocumentIds,
        selectedDocumentIds,
      );

      if (deselectedDocumentIds.length > 0) {
        acc.affectedContacts.push(contact);
        deselectedDocumentIds.forEach((id) => acc.deselectedDocumentIds.add(id));
      }

      return acc;
    },
    {
      affectedContacts: [] as ApiVaultTransferContact[],
      deselectedDocumentIds: new Set<string>(),
    },
  );
};

export const getContactsDocumentSelectionForHeirsSelection = (
  contactsDocumentSelection: Array<ApiVaultTransferContact>,
  selectedDocumentIds: Array<string>,
) => {
  return contactsDocumentSelection.map((contact) => {
    const shouldKeepWholeVault = contact.documentSelectionType === 'ALL';
    const filteredDocuments = shouldKeepWholeVault
      ? selectedDocumentIds
      : (
          contact.documents?.filter((document) =>
            selectedDocumentIds.includes(document.documentId),
          ) ?? []
        ).map((document) => document.documentId);

    return {
      userId: contact.contact.userId,
      selectionType: 'SPECIFIC_SELECTION' as const,
      documents: filteredDocuments,
    };
  });
};
